import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustStrip from "./components/TrustStrip";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonTable from "./components/ComparisonTable";
import BlogGrid from "./components/BlogGrid";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <main>
      <Navbar />
      <article>
        <HeroSection />
        <TrustStrip />
        <AboutSection />
        <CategoryGrid />
        <ComparisonTable />
        <BlogGrid />
        <CTASection />
      </article>
      <Footer />
    </main>
  );
}